import React from 'react';
import ReactDOM from 'react-dom';

import { Provider } from 'react-redux'
import { ThemeProvider } from '@material-ui/styles';

import './index.css';
import Theme from './Theme';
import App from './App';
import store from './store';
import * as serviceWorker from './serviceWorker';


ReactDOM.render(
//    <React.StrictMode>
    <ThemeProvider theme={Theme}>
        <Provider store={store}>
            <App />
        </Provider>
    </ThemeProvider>
//    </React.StrictMode>
    , document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
